import React, { useContext } from 'react';
import { Certificate, CERTIFICATES, CERTIFIER_STATUS } from './certificates';
import CertificateCard from './CertificateCard';
import { DialogWrappedComponentProps, FeedbackContext } from '../../providers/FeedbackProvider';
import { useIsMobile } from '../../helpers/useIsMobile';
import OutOfServiceCertificateDialog from './OutOfServiceCertificateDialog';

interface CertificateItemProps {
  certificate: Certificate;
  active: boolean;
  onSelect?(value: CERTIFICATES): void;
}

export default function CertificateItem(props: CertificateItemProps) {
  const { openBaseDialog } = useContext(FeedbackContext);
  const isMobile = useIsMobile();

  const onSelect = () => {
    if (props.certificate.certifierStatus === CERTIFIER_STATUS.INACTIVE) {
      openBaseDialog(
        (dialogProps: DialogWrappedComponentProps) => {
          return (
            <OutOfServiceCertificateDialog
              certificate={props.certificate}
              description={props.certificate.description || ''}
              onClick={dialogProps.onClose}
            />
          );
        },
        {
          width: isMobile ? '95vw' : '340px',
          height: 'full',
        }
      );

      return;
    }

    if (props.onSelect) props.onSelect(props.certificate.value);
  };

  const dataTestId = `certificateCard-${props.certificate.value}${props.active ? '-active' : ''} `;

  return (
    <div data-cy={`certificateCard-${props.certificate.value}`} onClick={onSelect} data-testid={dataTestId}>
      <CertificateCard
        active={props.active}
        clickable={!!props.onSelect}
        imagePath={props.certificate.imagePath}
        name={props.certificate.name}
        certifierStatus={props.certificate.certifierStatus}
      />
    </div>
  );
}
